import React, { useEffect, useState } from 'react'
import { useTranslate } from '../components/TranslationText';
import { checkLiveEventubraco } from '../components/CheckLiveEventUmbraco/checkLiveEventUmbraco';
import { pageTitle, whiteCard } from '../common/cssclasses';

export default function LiveStream() {
    const { translate } = useTranslate();

    const [liveEvent, setLiveEvent] = useState({});

    useEffect(() => {
        checkLiveEventubraco().then((res) => {
            setLiveEvent(res);
        })
    }, [])


    return (
        <>
            {liveEvent.isActive &&
                < >
                    <h2 className={pageTitle + " mb-main"}>
                        {liveEvent?.streamingName}
                    </h2>
                    <div className={whiteCard}>
                        <iframe width="100%" style={{ height: '80vh' }} className='border-15'
                            src={`${liveEvent?.streamingUrl}&autoplay=1`} title="YouTube video player"
                            frameborder="0" allow="accelerometer; autoplay; mute; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen={"true"}></iframe>
                    </div>
                </>
            }
        </>
    )
}
